<template>
    <section>
      <el-dialog
        title="编辑机器"
        :visible.sync="editFormVisible"
        v-model="editFormVisible"
        :close-on-click-modal="false"
        :before-close="closetc"
      >
        <el-form
          :model="editForm"
          label-width="140px"
          :rules="editFormRules"
          ref="editForm"
        >
          <el-form-item label="机器编号" prop="MachineNO">
            <el-input v-model="editForm.MachineNO" auto-complete="off"></el-input>
          </el-form-item>

          <el-form-item label="名称" prop="Name">
            <el-input v-model="editForm.Name" auto-complete="off"></el-input>
          </el-form-item>

          <el-form-item label="ConversationId" prop="ConversationId">
            <el-input v-model="editForm.ConversationId" auto-complete="off"></el-input>
          </el-form-item>

          <el-form-item label="所属分组">
            <el-select
              v-model="editForm.MachinesGroupID"
              filterable
              remote
              reserve-keyword
              placeholder="请输入关键词"
              :remote-method="remoteMethod"
              :loading="clinicLoading">
              <el-option
                v-for="item in options"
                :key="item.Id"
                :label="item.Name"
                :value="item.Id">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="配置模版">
            <el-select
              v-model="editForm.MachinesConfigID"
              filterable
              remote
              reserve-keyword
              placeholder="请输入关键词"
              :remote-method="remoteMethod2"
              :loading="configLoading">
              <el-option
                v-for="item in configOptions"
                :key="item.Id"
                :label="item.Name"
                :value="item.Id">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="智能体">
            <el-select
              v-model="editForm.BotsID"
              filterable
              remote
              reserve-keyword
              placeholder="请输入关键词"
              :remote-method="remoteBotsMethod"
              :loading="botsLoading">
              <el-option
                v-for="item in botsOptions"
                :key="item.Id"
                :label="item.Name"
                :value="item.Id">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="经度" prop="Longitude">
            <el-input v-model="editForm.Longitude" auto-complete="off"></el-input>
          </el-form-item>

          <el-form-item label="纬度" prop="Latitude">
            <el-input v-model="editForm.Latitude" auto-complete="off"></el-input>
          </el-form-item>

          <el-form-item label="远程" prop="SunLogin">
            <el-input v-model="editForm.SunLogin" auto-complete="off"></el-input>
          </el-form-item>

          <el-form-item label="地址" prop="Address">
            <el-input v-model="editForm.Address" auto-complete="off"></el-input>
          </el-form-item>

          <el-form-item label="联系人" prop="Contacts">
            <el-input v-model="editForm.Contacts" auto-complete="off"></el-input>
          </el-form-item>

          <el-form-item label="电话" prop="Phone">
            <el-input v-model="editForm.Phone" auto-complete="off"></el-input>
          </el-form-item>

        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="closetc">关闭</el-button>
          <el-button
            type="primary"
            @click.native="editSubmit"
            :loading="addLoading"
            >提交</el-button
          >
        </div>
      </el-dialog>
    </section>
  </template>
  
  
  
  <script>
  import { editMachines,getMachinesGroupListPage,getMachinesConfigListPage,getBotsListPage, BaseApiUrl } from "../../api/api";
  export default {
    props: {
        editForm:{}
    },
    data() {
      return {
        token: {
          Authorization: "Bearer ",
        },
        fileAction: BaseApiUrl + "/images/Upload/PicOne",
        editFormVisible:true,
        options: [],
        configOptions:[],
        botsOptions:[],
        editForm: {
          Id:0,
          Name: "",
          MachineNO:"",
          MachinesGroupID:"",
          BotsID:"",
          Longitude:"",
          Latitude:"",
          SunLogin:"",
          Address:"",
          Contacts:"",
          Phone:"",
          ConversationId:""
        },
        addLoading: false,
        clinicLoading:false,
        configLoading:false,
        botsLoading:false,
        editFormRules: {
          Name: [{ required: true, message: "请输入名称", trigger: "blur" }],
          MachineNO: [{ required: true, message: "请输入编号", trigger: "blur" }],
          ConversationId: [{ required: true, message: "请输入虚拟人会话ID", trigger: "blur" }],
        },
      };
    },
    methods: {
        remoteMethod(query){  //获取机器分组
            var that = this;
            console.log(111111);
            
            that.clinicLoading = true;
            var para = {
                key: query,
            };
            getMachinesGroupListPage(para).then(res=>{
                console.log("res",res)
                if(res.data.response != null){
                    var result = res.data.response
                    var list =  result.data;
                    that.clinicLoading = false;
                    that.options = result.data;
                    console.log("that.options.length",that.options.length)
                    if(that.options.length == 1){
                        that.editForm.MachinesGroupID = that.options[0].Id;
                    }
                    console.log(that.options);
                }
            });
      },
      remoteMethod2(query){  //获取机器分组
            var that = this;
            console.log(111111);
            
            that.configLoading = true;
            var para = {
                key: query,
            };
            getMachinesConfigListPage(para).then(res=>{
                console.log("res",res)
                if(res.data.response != null){
                    var result = res.data.response
                    var list =  result.data;
                    that.configLoading = false;
                    that.configOptions = result.data;
                    console.log("that.options.length",that.configOptions.length)
                    if(that.configOptions.length == 1){
                        that.editForm.MachinesConfigID = that.configOptions[0].Id;
                    }
                    console.log(that.configOptions);
                }
            });
      },
      remoteBotsMethod(query){  //智能体列表
            var that = this;
            that.botsLoading = true;
            var para = {
                key: query,
            };
            getBotsListPage(para).then(res=>{
                console.log("res",res)
                if(res.data.response != null){
                    var result = res.data.response
                    var list =  result.data;
                    that.botsLoading = false;
                    that.botsOptions = result.data;
                    console.log("that.options.length",that.botsOptions.length)
                    if(that.botsOptions.length == 1){
                        that.editForm.BotsID = that.botsOptions[0].Id;
                    }
                    console.log(that.botsOptions);
                }
            });
      },
      closetc(index) { 
        this.$parent.closetc(); //将值传给父组件 
      },
      //新增
      editSubmit: function () {
        let _this = this;
        this.$refs.editForm.validate((valid) => {
          if (valid) {
            this.$confirm("确认提交吗？", "提示", {}).then(() => {
              this.addLoading = true;
              //NProgress.start();
              let para = Object.assign({}, this.editForm);
              var user = JSON.parse(window.localStorage.user);
              if (user && user.uID > 0) {
              } else {
                this.$message({
                  message: "用户信息为空，先登录",
                  type: "error",
                });
                _this.$router.replace(
                  _this.$route.query.redirect ? _this.$route.query.redirect : "/"
                );
              }
              
              editMachines(para).then((res) => {
                this.addLoading = false;
                if (res.data.success) {
                  this.$message({
                    message: res.data.msg,
                    type: "success",
                  }); 
                  this.$parent.closetc(1);
                } else {
                  this.$message({
                    message: res.data.msg,
                    type: "error",
                  });
                }
              });
            });
          }
        });
      },
    },
    mounted() { 
        let tokenStr = window.localStorage.Token;
        this.token = {
            Authorization: "Bearer " + tokenStr,
        };
        this.remoteMethod('');
        this.remoteMethod2('');
        this.remoteBotsMethod('');
    },
  };
  </script> 